"use strict";

require("core-js/modules/esnext.global-this.js");
module.exports = require("./is-implemented")() ? globalThis : require("./implementation");